module.exports = __webpack_public_path__ + "img/img_lianghua_jihua_one@3x.c30c049d.png";